import _implicitStylesheets from "./contentCard.css";
import _implicitScopedStylesheets from "./contentCard.scoped.css?scoped=true";
import _axImage from "ax/image";
import _adsLink from "ads/link";
import _axTag from "ax/tag";
import _axBadge from "ax/badge";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"} class="axwp-content-card__title-link${0}"${"a0:target"}${"a0:aria-label"}${2}>${"t1"}</a>`;
const $fragment2 = parseFragment`<span${3}>${"t1"}</span>`;
const $fragment3 = parseFragment`<div class="axwp-content-card__excerpt${0}"${2}>${"t1"}</div>`;
const stc0 = {
  classMap: {
    "axwp-content-card": true
  },
  key: 0
};
const stc1 = {
  "axwp-content-card__image-link": true
};
const stc2 = {
  key: 6
};
const stc3 = {
  classMap: {
    "axwp-content-card__meta": true
  },
  key: 13
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  return [api_element("div", stc0, [api_custom_element("ads-link", _adsLink, {
    props: {
      "href": $cmp.cardLinkAttr,
      "name": $cmp.cardTitle
    },
    key: 1
  }, [$cmp.hasLink ? api_element("a", {
    classMap: stc1,
    attrs: {
      "href": $cmp.cardLinkAttr,
      "target": $cmp.cardTargetAttr,
      "aria-label": $cmp.cardTitle
    },
    key: 2
  }, [$cmp.hasImage ? api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.cardImage,
      "variant": "rounded",
      "shadow": "true",
      "width": "100%"
    },
    key: 3
  }) : null]) : null]), !$cmp.hasLink ? $cmp.hasImage ? api_custom_element("ax-image", _axImage, {
    props: {
      "imgSrc": $cmp.cardImage,
      "variant": "rounded",
      "shadow": "true",
      "width": "100%"
    },
    key: 4
  }) : null : null, api_custom_element("ads-link", _adsLink, {
    props: {
      "href": $cmp.cardLinkAttr,
      "label": $cmp.cardTitle,
      "name": $cmp.cardTitle
    },
    key: 5
  }, [api_element("h3", stc2, [$cmp.hasLink ? api_static_fragment($fragment1, 8, [api_static_part(0, {
    attrs: {
      "href": $cmp.cardLinkAttr,
      "target": $cmp.cardTargetAttr,
      "aria-label": $cmp.cardTitle
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.cardTitle))]) : null, !$cmp.hasLink ? api_static_fragment($fragment2, 10, [api_static_part(1, null, api_dynamic_text($cmp.cardTitle))]) : null])]), $cmp.hasExcerpt ? api_static_fragment($fragment3, 12, [api_static_part(1, null, api_dynamic_text($cmp.cardExcerpt))]) : null, api_element("div", stc3, [$cmp.hasTag ? api_custom_element("ax-tag", _axTag, {
    props: {
      "href": $cmp.validTagLink,
      "text": $cmp.tagText
    },
    key: 14
  }) : null, $cmp.hasBadge ? api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.badgeLabel
    },
    key: 15
  }) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-1urr3n3tbar";
tmpl.legacyStylesheetToken = "undefined-_contentCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
